var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "steps-content clearfix" },
    [
      _vm._l(_vm.steps, function (step) {
        return _c(
          "div",
          {
            key: step.text,
            staticClass: "step",
            class: step.text === _vm.currentStep?.text ? "active" : "",
            style: _vm.stepWidth,
          },
          [_c("p", [_vm._v(_vm._s(step.text))])]
        )
      }),
      _c("div", {
        staticClass: "fake-background transition-slow",
        style: `${_vm.stepWidth} ${_vm.stepPosition}`,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }